import React, { Children, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';
import { getCurrentSelected, getValueWithPadding } from '../utils/smartutils';

export const CarouselItem = ({ children, width }) => {
  const shouldMarginRight = () => width < 100;
  return (
    <div
      className={`smart-carousel-wrapper-item ${
        shouldMarginRight() ? 'with-margin' : ''
      }`}
      style={{ width: `${width}%` }}
    >
      {children}
    </div>
  );
};

CarouselItem.propTypes = {
  children: PropTypes.element.isRequired,
  width: PropTypes.number,
};

CarouselItem.defaultProps = {
  width: 100,
};

const Carousel = ({
  t,
  children,
  status,
  showStatus,
  initialActiveStep,
  translateXPercentage,
  colorStatus,
  whatsCurrentIndex,
}) => {
  const getIndexByStep = (step) => {
    return step ? step - 1 : 0;
  };

  const [activeIndex, setActiveIndex] = useState(
    getIndexByStep(initialActiveStep)
  );

  const isLastChild = () => {
    return activeIndex === Children.count(children) - 1;
  };

  const isFirstChild = () => {
    return activeIndex === 0;
  };

  const updateIndex = (newIndex) => {
    if (newIndex >= 0 && newIndex < Children.count(children)) {
      setActiveIndex(newIndex);
    }
  };

  const getListLength = () => {
    const length = Array.isArray(children) ? children.length : 1;
    if (length > 9) {
      return String(length);
    }
    return getValueWithPadding(length);
  };

  const getStatus = () => {
    return (
      <div className={`smart-carousel-wrapper-status ${colorStatus}-color`}>
        <span>{getCurrentSelected(activeIndex)}</span>
        <span>{t('general.in')}</span>
        <span>{getListLength()}</span>
      </div>
    );
  };

  useEffect(() => {
    if (status) {
      status({
        step: getCurrentSelected(activeIndex),
        length: getListLength(),
      });
    }
    if (whatsCurrentIndex) {
      whatsCurrentIndex(activeIndex);
    }
  }, [activeIndex]);

  useEffect(() => {
    setActiveIndex(getIndexByStep(initialActiveStep));
  }, [initialActiveStep]);

  return (
    <div className="smart-carousel-wrapper">
      {!isFirstChild() && (
        <button
          className="action-left"
          type="button"
          onClick={() => updateIndex(activeIndex - 1)}
        >
          <ChevronLeftIcon />
        </button>
      )}
      {!isLastChild() && (
        <button
          className="action-right"
          type="button"
          onClick={() => updateIndex(activeIndex + 1)}
        >
          <ChevronRightIcon />
        </button>
      )}
      <div
        className="smart-carousel-wrapper-inner"
        style={{
          transform: `translateX(-${activeIndex * translateXPercentage}%)`,
        }}
      >
        {Array.isArray(children) ? children.map((child) => child) : children}
      </div>

      {showStatus && getStatus()}
    </div>
  );
};

Carousel.propTypes = {
  t: PropTypes.func.isRequired,
  whatsCurrentIndex: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  showStatus: PropTypes.bool,
  status: PropTypes.func,
  initialActiveStep: PropTypes.number,
  translateXPercentage: PropTypes.number,
  colorStatus: PropTypes.string,
};

Carousel.defaultProps = {
  showStatus: true,
  status: undefined,
  whatsCurrentIndex: undefined,
  initialActiveStep: 0,
  translateXPercentage: 100,
  colorStatus: 'default',
};

export default withTranslation('translation')(Carousel);
